import { SDK_API } from "@/configs/APIs";
import { DEFAULT_VALUES, DEVICE_TYPES, STATUS_RESPONSES } from "@/configs/SDK";
import { STATUS_MESSAGES } from "@/messages/System";
import { ENV_CONFIGS, RAKUTEN_LOGIN_URL } from "@/configs/Settings";
import getCountry from "@/ultis/CountryLocation";
import { mapGetters } from "vuex";
import { isInIframe, hasLs } from "@/ultis/Helper";

export default {
   name: "SdkMixin",
   data() {
      return {
         loginURL: RAKUTEN_LOGIN_URL,
         intervalGetSSOId: null,
         isDetectedLocation: false,
         isInIframe: isInIframe()
      };
   },
   computed: {
      ...mapGetters(["country"]),
      getLoginURL() {
         const params = this.country === "JP" ? "japan_login" : "global_login";
         return `${this.loginURL}/${params}/?redirect_uri=${window.location.origin}/login`;
      }
   },
   watch: {},
   created() {},
   mounted() {},
   methods: {
      async saveCurrentPageName(routeName = null, routerParams = null, routerQuery = null) {
         localStorage.setItem("redirect_route_name", routeName || this.$route.name);
         console.log("routeName", routeName);
         let params = JSON.stringify(routerParams) || (JSON.stringify(this.$route.params) !== "{}" ? JSON.stringify(this.$route.params) : "");
         let query = JSON.stringify(routerQuery) || (JSON.stringify(this.$route.query) !== "{}" ? JSON.stringify(this.$route.query) : "");
         localStorage.setItem("redirect_route_params", params);
         localStorage.setItem("redirect_route_query", query);
      },
      async detectLocation() {
         const lsSupported = hasLs();
         if (ENV_CONFIGS.IS_LOCAL) {
            if (lsSupported) localStorage.setItem("country_code", DEFAULT_VALUES.LOCATION);
            //this.$cookies.set("country_code", DEFAULT_VALUES.LOCATION, "1m");
            this.$http.defaults.headers.common["location"] = DEFAULT_VALUES.LOCATION;
            this.$store.commit("SET_COUNTRY", DEFAULT_VALUES.LOCATION);
         } else {
            let _this = this;
            //const countryCode = this.$cookies.get("country_code");
            let countryCode = null;
            if (lsSupported) localStorage.getItem("country_code");
            if (countryCode) {
               console.log("Country", countryCode);
               this.$store.commit("SET_COUNTRY", countryCode);
               this.$http.defaults.headers.common["location"] = countryCode;
            } else {
               await getCountry()
                  .then((res) => {
                     console.log("Country", res);
                     if (lsSupported) localStorage.setItem("country_code", res);
                     //_this.$cookies.set("country_code", res, "1m");
                     _this.$store.commit("SET_COUNTRY", res);
                     _this.$http.defaults.headers.common["location"] = res || DEFAULT_VALUES.LOCATION;
                  })
                  .catch((error) => {
                     console.log(DEFAULT_VALUES.LOCATION, error);
                     _this.$http.defaults.headers.common["location"] = DEFAULT_VALUES.LOCATION;
                  });
            }
         }
         this.isDetectedLocation = true;
      },
      logout() {
         delete this.$http.defaults.headers.common["Authorization"];
         this.$cookies.remove("guest_token");
         this.$cookies.remove("access_token");
         this.$store.dispatch("userLogin", null);
         if (this.$route.name === "WatchStream" && !this.isInIframe) {
            // this.$router.push({ name: "LandingPage" });
            window.location.href = "/";
         }
         if (this.isInIframe) {
            parent.postMessage(
               JSON.stringify({
                  type: "LOGIN_FAILED"
               }),
               process.env.VUE_APP_ALLOW_ORIGIN
            );
         }
      },
      async login({ beliveId, signInType }) {
         const dataParams = {
            deviceUdid: null,
            deviceType: parseInt(DEVICE_TYPES.WEB),
            latitude: 0,
            longitude: 0,
            beliveId,
            signInType
         };
         try {
            const {
               data: { code, data }
            } = await this.$http.post(SDK_API.BELIVE_LOGIN, dataParams);
            const { accessToken } = data;
            console.log("login", { code, data });
            if (code === STATUS_RESPONSES.SUCCESS) {
               this.$http.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
               this.$cookies.remove("guest_token");
               this.$cookies.set("access_token", accessToken, 0);
               let dataLogin = data;
               if (dataLogin?.userInfo) this.$store.dispatch("userLogin", dataLogin);
               else dataLogin = await this.checkIsLoggedIn(accessToken)
               return dataLogin;
            } else {
               this.$toastr.e("Login failed!", STATUS_MESSAGES.ERROR);
               return null;
            }
         } catch (error) {
            console.error(`Login error: ${error.toString()}`);
         }
         return null;
      },
      async checkIsLoggedIn(newToken = null) {
         //Check if cookie has token
         let token = this.isInIframe ? newToken : this.$cookies.get("access_token") || null;
         if (!token && !this.isInIframe) token = this.$cookies.get("guest_token") || null;
         try {
            if (token) {
               const {
                  data: { code, data }
               } = await this.$http.post(SDK_API.CHECK_LOGIN, {}, { headers: { Authorization: `Bearer ${token}` } });
               if (code === STATUS_RESPONSES.SUCCESS) {
                  this.$http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
                  const dataLogin = { ...data, accessToken: token }
                  this.$store.dispatch("userLogin", dataLogin);
                  return dataLogin;
               } else if (code === STATUS_RESPONSES.UNAUTHORIZED || code === STATUS_RESPONSES.USER_LOGGED_ANOTHER_DEVICE) {
                  this.logout();
               }
            } else {
               if (!this.isInIframe) await this.guestLogin();
            }
         } catch (error) {
            //
         }
         return null;
      },
      async guestLogin() {
         this.$cookies.remove("access_token");
         let oldGuestToken = this.$cookies.get("guest_token");
         if (oldGuestToken) {
            let currentUserStorage = JSON.parse(localStorage?.getItem("currentUser"));
            if (currentUserStorage) {
               this.$store.dispatch("userLogin", currentUserStorage);
            }
            this.$http.defaults.headers.common["Authorization"] = `Bearer ${oldGuestToken}`;
         } else {
            let token = "";
            let indexUser = Math.floor(1000 + Math.random() * 90000);
            try {
               const response = await this.$http.post(SDK_API.GUEST_LOGIN, {
                  deviceUdid: `web-client-${indexUser}`,
                  deviceType: parseInt(DEVICE_TYPES.WEB)
               });
               if (response.data.code === STATUS_RESPONSES.SUCCESS && response.data.data.accessToken) {
                  this.$store.dispatch("userLogin", response.data.data);
                  token = response.data.data.accessToken;
                  this.$cookies.set("guest_token", token);
                  this.$http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
               } else this.$toastr.e(response.data.message, STATUS_MESSAGES.ERROR);
            } catch (error) {
               //
            }
         }
      }
   }
};
